<template>
  <div :class="['list-item', { 'search_result': isSearchResult, 'active': active }]">
    <div class="list-item__rank" v-if="isRank">
      <span>{{ rank }}</span>
    </div>
    <div class="list-item__avatar">
      <div class="avatar_status">
        <img :src="avatar" alt="" style="cursor: pointer" @click.prevent="showUserProfile()">
        <div :class="[ isOnline() ? 'bubble_online' : 'bubble_ofline' ]">
          <span class="bubble-outer-dot"> <span class="bubble-inner-dot"></span> </span>
        </div>
      </div>
      <div class="list-item__info">
        <span :class="['list-item__info__name', { 'blocked' : isBlocked }]">
         {{ username }}
        </span>
        <div class="list-item__points" v-if="isRank">{{ points }}</div>
        <div class="list-item__level" v-else-if="!hasPrivateProfile">Level: {{ level }}</div>
      </div>
    </div>
    <div class="list_actions" v-if="!active">
      <div class="action_container">
        <block-alt v-if="isBlocked" :action-on-click="unblock"/>
        <template v-else>
          <chat-bubble :class="['chat_action', { deactivated: isBot || hasBlockedYou }]"
                       v-if="getMessagingConfig.messagingEnabled && !isModal"
                       :username="username"/>
          <star v-if="!isModal" :action-on-click="markFavorite" :is-checked="isFavorite" :key-id="_uid"/>
          <versus :class="[{ deactivated: !isOnline() }]" :is-modal="isModal" :action-on-click="playAgainst"/>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Star from '@/components/home/shared/Star';
import ChatBubble from '@/components/home/shared/ChatBubble';
import Versus from '@/components/home/shared/Versus';
import BlockAlt from '@/components/home/shared/BlockAlternate';
import bus from '@/common/eventBus';
import { ChecksToStartNewGame } from '@/common/mixins/rematch/rematch';

export default {
  name: 'favorite-user',
  mixins: [ChecksToStartNewGame],
  inject: {
    isModal: {
      default: false,
    },
    isRank: {
      default: false,
    },
  },
  props: {
    avatar: { type: String, required: true },
    username: { type: String, required: true },
    level: { type: Number, required: true },
    isSearchResult: Boolean,
    isBlocked: Boolean,
    isFavorite: Boolean,
    isBot: Boolean,
    hasBlockedYou: Boolean,
    hasPrivateProfile: Boolean,
    points: { type: Number, required: false, default: 0 },
    rank: { type: Number, required: false, default: 0 },
    active: { type: Boolean, required: false, default: false },
  },
  components: {
    Star,
    Versus,
    ChatBubble,
    BlockAlt,
  },
  methods: {
    ...mapMutations('users', [
      'setSelectedUser',
    ]),
    ...mapActions('users', [
      'markFavoriteUser',
      'markBlockedUser',
    ]),
    showUserProfile() {
      this.setSelectedUser(this.username);
      this.$router.push({ name: 'other-user-profile' });
    },
    markFavorite() {
      bus.$emit('favorite', this.username);
      this.markFavoriteUser(this.username);
    },
    unblock() {
      this.markBlockedUser(this.username);
    },
    playAgainst() {
      this.checkGameValidations(false, this.username, this.avatar, this.level);
    },
    isOnline() {
      return this.isBot || (this.getOnlineUsers.filter(user => user && user.username === this.username).length && !this.hasBlockedYou);
    },
  },
  computed: {
    ...mapGetters('users', [
      'getOnlineUsers',
    ]),
    ...mapGetters('common', [
      'getMessagingConfig',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/users/FavoriteUser.vue